export const changeProspect = 'Change Prospect';
export const addProspect = 'Add Prospect';
export const prospectNotesAdm = 'Prospect Notes';
export const deleteProspect = 'Delete Prospect';
export const Configuration = 'Configuration';
export const maintenance = 'Maintenance'
export const addBatch = 'Add';
export const input = 'Input';
export const printBatch = 'Print';
export const deleteBatch = 'Delete';
export const distributeBatch = 'Distribute';
export const changeAddress = 'Change Address'
export const newsFeed = 'CAMS News Feed';
export const changeTransfer = 'Transfer';
export const financialTransfer = 'Transfer';
export const financialHolds = 'Holds';
export const studentNotes = 'Student Notes';
export const workstudySetup = 'Workstudy Setup';
export const awardReferrence = 'Award Reference';
export const schedule = 'Schedule';
export const officialTranscript = 'Official Transcript';
export const advisorTranscript = 'Advisors Transcript';
export const catalogMaintenance = 'Maintenance';
export const copyCatalog = 'Copy Catalog';
export const scheduleRegistration = 'Schedule Registration';
export const dataEntry = 'Data Entry';
export const dataRangeEntry = 'Date Range Entry';
export const studentEvaluation = 'Student Evaluation';
export const billingAuthorize = 'Authorize';
export const changeBillingMaintenace = 'Maintenance';
export const generalLegerPostAccess = 'General Ledger';
export const generalLegerPayableAccess = 'Accounts Payable';
export const billingRecreateAccess = 'General Ledger';
export const billingRecreatePayable = 'Accounts Payable';
export const changeCashierEntry = 'Cashier Entry'
export const change1098TReportAccess = '1098T Export'
export const studentPictureUpload = 'Student Picture Load'
export const facultyPictureLoadData = 'Faculty Picture Load'
export const addProspectActivity = 'Add Prospect Activity'
export const addStudentActivity = 'Add Student Activity'
export const statusChanges = 'Status Changes'
export const evaluationSetup = 'CRS Evaluation Setup';
export const transcriptBatches = 'Transcript Batches';
export const massUpdateStatus = 'Mass Update Status';
export const massAddAudit = 'Mass Add Audit';
export const mergeOffering = 'Merge Offering';
export const sap = 'SAP';
export const billingProcess = 'Billing Processes';
export const noShowRemove = 'No Show Remove';
export const r2t4 = 'R2T4';
export const latePaymentFees = 'Late Payment Fees';
export const degreeVerify = 'Degree Verify';
export const nysSiris = 'NYS SIRIS';
export const khedsExport = 'KHEDS Export';
export const texasStudentCensus = 'CBM0C1 - Student Census';
export const graduation = 'CBM009 - Graduation';
export const ceStudents = 'CBM00A - CE Students';
export const studentSchedule = 'CBM00S - Student Schedule';
export const censusStudentSchedule = 'CBM0CS - Census Student Schedule';
export const endSemStudents = 'CBM0E1 - End Sem Students';
export const CbmceClasses = 'CBM00C - CE Classes';
export const txFinAidSystem = 'TFADS - TX Fin Aid DB Sys';
export const successInit = 'CBM002 - Success Init';
export const faculty = 'CBM008 - Faculty';
export const User = 'User Administration';
export const role = 'Role Administration';
export const fpAdmin = 'FP Admin Role Access';
export const deleteStudent = 'Delete Students';
export const rebuildRepeats = 'Rebuild Repeats';
export const asnImport = 'ASN Import';
export const billingImport = 'Billing Import';
export const codExport = 'COD Export';
export const gainfulEmploymentExport = 'Gainful Employment Export';
// The existing CAMSMenu node was renamed to IPEDS; its grants remain on that node.
export const ipedsReports = 'IPEDS';
export const powerfaids = 'Powerfaids';
export const nslcExport = 'NSC Export';
export const doctrackAutoload = 'Doctrack AutoLoad';
export const config = 'Configure';
export const currencyTp = 'Currency Types';
export const exRates = 'Exchange Rates';
export const customGrede = 'Custom Grade Entry';
export const userDefined = 'User Defined Field Setup';
export const risk = 'Risk Indicator Setup';
export const testScore = 'Test Score Table Setup';
export const emailTemp = 'Email Templates';
export const institutionalSAP = 'Institutional SAP';
export const governmentSAP = 'Governmental SAP';
export const gradeGroup = 'Grade Groups';
export const docTrack = 'DocTrack Setup';
export const stateReport = 'State Reports Lookup';
export const portalURL = 'Portal URL Ref';
export const termCalender = 'Term Calendar';
export const terms = 'Terms';
export const countrySet = 'County Setup';
export const locationSet = 'Location Setup';
export const gradeEntry = 'Grade Entry'
export const numberGradeEntry = 'Number Grade Entry'
export const authorizePortalGradesReg = 'Authorize Portal Grades'
export const single = 'Single';
export const packagesCriteria = 'Package Criteria';
export const awardMethodology = 'Award Methodology';
export const budget = 'Budgets';
export const lifeTimeLimits = 'Lifetime Limits';
export const FinancialPackage = 'Package';
export const degreeAuditSetup = 'Degree Audit Setup';
export const bulkProspectImport = 'Bulk Prospect Import';
export const testScoreMapping = 'Test Score Mapping';
export const applyTexas = 'Apply Texas Import';
export const testScoresImport = 'Test Scores Import';
export const prospectStudentImportLabel = 'Prospect/Student Import';
export const speedeCollegeTranscript = 'Speede College Transcript';
export const massStudentRegistration = 'Mass Student Registration';
export const codMessages = 'COD';
export const workStudyMaintenance = 'Work Study Maintenance';
export const yearlySetup = 'Yearly Setup';
export const loadPell = 'Load Pell';
export const transactionDoc = 'Transaction Documents';
export const portNEWS = 'Announcements';
export const paymentCONFIG = 'Payment Configuration';
export const studentCONFIG = 'Student Configuration';
export const facultyCONFIG = 'Faculty Configuration';
export const applicationCONFIG = 'Application Configuration';
export const miskCONFIG = 'Misc Configuration';
export const ipLock = 'IP Lockout';
export const gradeAppCONFIG = 'Grad App Configuration';
export const BRANDING = 'Branding';
export const tablemainten = 'Table Maintenance';
export const errorLOG = 'View Error Log';
export const rebuildGRADE = 'Grades';
export const enroll = 'Enrollment Counts';
export const isirDirect = 'ISIR Direct'
export const codImport = 'COD Import'
export const codCBImport = 'COD Campus-Based Import'
export const codMessagesImport = 'COD Message'
export const codEdeAwards = 'EDE Awards'
export const powerFaidsImport = 'PowerFaids'
export const RegMaintenance = 'Maintenance'
export const studentAccess = 'Student Access';
export const studentSevis = 'Student SEVIS';
export const laptopTracking = 'Laptop Tracking';
export const evaluationApplicant = 'Applicant';
export const setup = 'Setup';
export const offerings = 'Offerings';
export const studentStatu = 'Student Status';
export const documentTracking = 'Document Tracking';
export const masterCourses = 'Master Courses'
export const offeringMaintenance = 'Offering Maintenance';
export const timeSlotReference = 'Time Slot Reference';
export const tuitionandRefunds = 'Tuition and Refunds';
export const crossListedCourses = 'Cross Listed Courses';
export const Degrees = 'Degrees';
export const Credentials = 'Credentials';
export const Status = 'Status';
export const lookupLetterSequence = 'Letter Sequences'
export const lookupHighSchool = 'High School'
export const lookupCollege = 'College Names'
export const RegistrationRegister = 'Register';
export const RegisterUnofficial = 'Unofficial';
export const prospectQuestionsId = 'Prospect Questions';
export const prospectMergeId = 'Merge';
export const prospectInternationalId = 'Prospect International';
export const prospectCitizenshipId = 'Prospect Citizenship'
export const ReportstForm = '1098T Form'
export const organizationAdd = 'Add';
export const organizationChange = 'Change';
export const organizationDelete = 'Delete';
export const contactsAdd = 'Add/Change';
export const contactsDelete = 'Delete';
export const changeStudent = "Change Student";
export const addStudent = "Add Student";
export const delete_Student = 'Delete Student'
export const studentRisk = 'Student Risk';
export const examID = 'Generate Exam IDs';
export const semaph = 'Semaphores';
export const registrationSemaph = 'Registration';
export const admissionSemaph = 'Admission';
export const changeFaculty = 'Change Faculty';
export const addFaculty = 'Add Faculty';
export const deleteFaculty = 'Delete Faculty';
export const facultyMaintenance = 'Faculty Maintenance';
export const exportSpeedeCollegeTranscript = 'Speede College Transcript';
export const dataQueryExport = 'Data Query';
export const ReportConfiguration = 'Report Configuration';
export const ReportstaForm = 'T4A Form'
export const ReporttaForm = 'T2202 Form'
export const enrollement = 'Enrollment'
export const awardLetters = 'Award Letters'
export const reportByor = 'BYOR'
export const trasformationTemplate = 'Email Templates'
export const Schedule = 'Schedule'
export const publisherSetup = 'Publisher Event Setup'
export const GradeCards = 'Grade Cards'
export const printOffering = 'Print Offering';
export const courseManagementRoles = 'Course Management Roles'
export const Statements = 'Statements'
export const EnrollmentVerification = 'Enrollment Verification'
export const workingToDo = 'Working To-Do'
export const manageForms = 'Tools-Manage Forms'
export const manageProperties = 'Student Life-Properties-Manage'
export const manageAmenities = 'Student Life-Amenities-Manage'
export const ExtensionsSupported = 'image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain';
export const MAX_FILE_SIZE = 10000000;
export const AccessLevel = {
    NoAccess: 0,
    ReadOnly: 1,
    ReadWrite: 2 
}
export const semaphoreOperations = {
    StudentAdmission: 'Student Admission',
    ProspectAdmission: 'Prospect Admission'
}
export const manageMealPlans = 'Student Life-Meal Plans-Manage'
export const institutionalCalendar = 'Institutional Calendar'
export const ModuleOrder = {
    degreeAuditSetup: 2,
    facultyMaintenance: 13
}
export const studentAlertKey = "studentId-alert";
// Refund Policy glossary display text (mirrors SMLite.Service.Core.Enums.RefundPolicy).
export const RefundPolicy = Object.freeze({
    Standard: 'Standard',
    StandardPlus: 'Standard Plus',
    Daily: 'Daily'
});
export const isRefundPolicy = (displayText, policy) =>
    String(displayText ?? '').trim().toUpperCase() === policy.toUpperCase();
// Refunds default to this percent after the last refund period.
export const NoRefundPercent = 0;
export const AddressStatus = {
    Active: 1,
    Inactive: 0};

export const AddressTypeDisplayNames = {
    HOME: 'Home',
    LOCAL: 'Local',
    BILLING: 'Billing'
};

// Mirrors AdmissionsService.Core.Constants.DualEnrollmentStatusCodes
export const DualEnrollmentStatus = {
    NOT_DUAL_ENROLLED: 1,
    WITHIN_PROGRAM: 2,
    OUTSIDE_PROGRAM: 3
};

// The two spellings the State glossary uses for Texas -- some tenants seed the USPS
// abbreviation in DisplayText, others the full name. Values are kept lowercase and every caller
// lowercases the selected state before comparing, so 'TX', 'tx', 'Texas' and ' TEXAS ' all resolve
// the same way and the County picklist shows on exactly the same addresses everywhere.
// Mirrors the extract-side check St.DisplayText IN ('TX','TEXAS') in
// CAMS_StateReports_Texas_Holding_CBM001 / _TFADS (case-insensitive there by collation).
export const TEXAS_STATE_VALUES = ['tx', 'texas'];

export const defaultColumnWidth = 20;
export const employerConst = "Employer"

export const ERROR_TYPE_LABELS = {
    data_type_mismatch: 'Data type / size mismatch',
    invalid_choice: 'Choice option not valid',
    unknown: 'Unknown'
};

// Global search + deep-link gate shared constants. Module order values must
// match the sidebar_menu parentLevel order coming from the backend (see
// DeepLinkConstants.ModuleOrder on the .NET side for the subset used by the
// deep-link resolvers; Student Life=12 is a frontend-only mapping).
export const GLOBAL_SEARCH_LISTBOX_ID = 'gsearch-listbox';
export const GLOBAL_SEARCH_MIN_QUERY_LENGTH = 2;
export const MODULE_TO_ORDER = {
    Admissions: 1,
    Registration: 2,
    Billing: 3,
    'Financial Aid': 4,
    'System Manager': 6,
    'Student Life': 12,
    // WI 303847 — Faculty Maintenance (the faculty detail page) hangs off the
    // "CAMS Manager" sidebar module, moduleorder 13, not System Manager (6).
    // buildPermissionIndex resolves a permission row's module by matching this
    // map's values against item.moduleorder, so an unmapped 13 silently drops
    // every CAMS Manager link from the search results.
    'CAMS Manager': 13
};

// Gate route path used by global-search results to hydrate legacy pages with
// the clicked entity before rendering. Mounted in route/routeConfig.js.
// Format: /deeplink/{entityType}/{entityId}/go{targetPath}
export const DEEPLINK_GATE_ROUTE_BASE = '/deeplink';
export const DEEPLINK_GATE_ROUTE_PATH = `${DEEPLINK_GATE_ROUTE_BASE}/:entityType/:entityId/go`;
export const buildDeepLinkGateUrl = (entityType, entityId, targetPath) =>
    `${DEEPLINK_GATE_ROUTE_BASE}/${entityType}/${entityId}/go${targetPath}`;

// ─── Badge / Status chip enums ────────────────────────────────────────────────

export const VARIANT = {
    ERROR:         'error',
    SUCCESS:       'success',
    WARNING:       'warning',
    IN_PROGRESS:   'in-progress',
    INFORMATIONAL: 'informational',
    NEUTRAL:       'neutral',
};

export const CHIP_SHAPE = {
    BADGE: 'badge',
    PILL:  'pill',
};

export const CHIP_SIZE = {
    SM: 'sm',
    MD: 'md',
};

/**
 * Canonical status string → VARIANT mapping.
 * Keys are lowercased API/data values. Unlisted values fall back to VARIANT.NEUTRAL.
 *
 * Semantic rules locked by the design system:
 *   Holds               → always VARIANT.WARNING  (yellow)
 *   Dropped / Withdrawn → always VARIANT.NEUTRAL  (gray)
 *   Cancelled           → always VARIANT.NEUTRAL  (gray — historical, not an error)
 */
export const STATUS_VARIANT_MAP = {
    // Informational / Designation (Teal)
    active:             VARIANT.INFORMATIONAL,
    enrolled:           VARIANT.INFORMATIONAL,
    undergraduate:      VARIANT.INFORMATIONAL,
    graduate:           VARIANT.INFORMATIONAL,
    'full time':        VARIANT.INFORMATIONAL,
    'part time':        VARIANT.INFORMATIONAL,

    // Success / Met (Green)
    met:                VARIANT.SUCCESS,
    approved:           VARIANT.SUCCESS,
    accepted:           VARIANT.SUCCESS,
    exported:           VARIANT.SUCCESS,
    disbursed:          VARIANT.SUCCESS,
    complete:           VARIANT.SUCCESS,
    completed:          VARIANT.SUCCESS,
    clean:              VARIANT.SUCCESS,

    // Error / Not Met (Red)
    'not met':          VARIANT.ERROR,
    error:              VARIANT.ERROR,
    failed:             VARIANT.ERROR,
    denied:             VARIANT.ERROR,
    rejected:           VARIANT.ERROR,

    // Warning / Pending (Yellow)
    hold:               VARIANT.WARNING,
    holds:              VARIANT.WARNING,
    pending:            VARIANT.WARNING,
    warning:            VARIANT.WARNING,
    'leave of absence': VARIANT.WARNING,

    // In Progress / Caution (Orange)
    'in progress':      VARIANT.IN_PROGRESS,
    'in-progress':      VARIANT.IN_PROGRESS,
    processing:         VARIANT.IN_PROGRESS,

    // Neutral / Inactive / Historical (Gray)
    dropped:            VARIANT.NEUTRAL,
    withdrawn:          VARIANT.NEUTRAL,
    cancelled:          VARIANT.NEUTRAL,
    canceled:           VARIANT.NEUTRAL,
    inactive:           VARIANT.NEUTRAL,
    historical:         VARIANT.NEUTRAL,
    'not exported':     VARIANT.NEUTRAL,
};

/** Resolve a raw status string to a VARIANT value. Returns VARIANT.NEUTRAL for unrecognised input. */
export const resolveVariant = (status) =>
    STATUS_VARIANT_MAP[String(status ?? '').trim().toLowerCase()] ?? VARIANT.NEUTRAL;

export const TEST_SCORE_RESULT_TYPE = { SCORE: 1, PASS_FAIL: 2 };
